module.exports = __webpack_public_path__ + "static/media/square-up-right-arrow.98cc4927.svg";